<template>
  <v-card>
    <v-card-title>{{ title ? title : defaultTitle }}</v-card-title>
    <v-card-text>
      <p v-for="item in messages" :key="item" :value="item">
        {{item}}
      </p>
    </v-card-text>
    <v-card-actions>
      <v-col class="text-center">
        <v-btn :color="isDarkTheme ? 'secondary' : 'primary'" :loading="loading" @click="confirm"> <v-icon>mdi-check</v-icon> Ok </v-btn>
      </v-col>
    </v-card-actions>
  </v-card>
</template>
<script lang="ts">
import Vue, { defineComponent } from "vue";
export default defineComponent({
  props: {
    title:{
      type: String,
      required: false,

    },
    messages: {
      required: false,
      type: Array<any>(),
    },
    loading: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      defaultTitle: "Process Confirmation",
      valid: true,
    };
  },
  methods: {
    confirm(): void {
      this.$emit("cancel");
    },
  },
  computed: {
    isDarkTheme() {
      return this.$vuetify.theme.current.dark;
    },
  },
});
</script>
